var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_4639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6265 11.7193L15.9065 17.4527L13.7065 15.2527C13.587 15.1131 13.4399 14.9997 13.2745 14.9197C13.109 14.8397 12.9289 14.7947 12.7452 14.7876C12.5616 14.7805 12.3785 14.8115 12.2074 14.8785C12.0363 14.9455 11.8809 15.0472 11.751 15.1771C11.621 15.3071 11.5194 15.4625 11.4523 15.6336C11.3853 15.8047 11.3544 15.9878 11.3614 16.1714C11.3685 16.355 11.4135 16.5352 11.4935 16.7006C11.5736 16.8661 11.6869 17.0132 11.8265 17.1327L14.9598 20.2793C15.0844 20.4029 15.2322 20.5007 15.3946 20.567C15.5571 20.6334 15.731 20.667 15.9065 20.666C16.2563 20.6645 16.5915 20.5257 16.8398 20.2793L23.5065 13.6127C23.6315 13.4887 23.7307 13.3413 23.7984 13.1788C23.8661 13.0163 23.9009 12.842 23.9009 12.666C23.9009 12.49 23.8661 12.3157 23.7984 12.1532C23.7307 11.9908 23.6315 11.8433 23.5065 11.7193C23.2567 11.471 22.9188 11.3316 22.5665 11.3316C22.2143 11.3316 21.8763 11.471 21.6265 11.7193ZM17.9998 2.66602C15.3628 2.66602 12.7849 3.448 10.5922 4.91309C8.39958 6.37817 6.69062 8.46055 5.68145 10.8969C4.67228 13.3333 4.40824 16.0141 4.92271 18.6006C5.43718 21.187 6.70705 23.5627 8.57175 25.4274C10.4365 27.2921 12.8122 28.562 15.3986 29.0765C17.9851 29.591 20.6659 29.3269 23.1023 28.3177C25.5386 27.3086 27.621 25.5996 29.0861 23.4069C30.5512 21.2143 31.3332 18.6364 31.3332 15.9993C31.3332 14.2484 30.9883 12.5146 30.3182 10.8969C29.6482 9.27923 28.666 7.80937 27.4279 6.57126C26.1898 5.33314 24.72 4.35102 23.1023 3.68096C21.4846 3.01089 19.7508 2.66602 17.9998 2.66602ZM17.9998 26.666C15.8902 26.666 13.8279 26.0404 12.0738 24.8684C10.3196 23.6963 8.95246 22.0304 8.14513 20.0813C7.33779 18.1322 7.12656 15.9875 7.53813 13.9184C7.94971 11.8493 8.96561 9.94864 10.4574 8.45688C11.9491 6.96512 13.8497 5.94922 15.9189 5.53764C17.988 5.12606 20.1327 5.3373 22.0818 6.14463C24.0309 6.95197 25.6968 8.31914 26.8689 10.0733C28.0409 11.8274 28.6665 13.8897 28.6665 15.9993C28.6665 18.8283 27.5427 21.5414 25.5423 23.5418C23.5419 25.5422 20.8288 26.666 17.9998 26.666Z",
    fill: "#007CDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_4639",
    x: -2,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_4639"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_4639",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.4d4370563d6e8ffcac680f2bd80bd591.svg";
export { ForwardRef as ReactComponent };